import { cwslapi } from "../index";


// 领取VIP福利
export const claimVipBonusApi = (data) => { 
  return cwslapi({
    url: "/AnimalVoteActivity/claimVipBonus",
    method: "post",
    data,
  });
};



// 获取宠物投票活动信息
export const getActivityInfoApi = (data) => { 
  return cwslapi({
    url: "/AnimalVoteActivity/getActivityInfo",
    method: "post",
    data,
  });
};


// 获取个人贡献榜
export const getPersonalContributionRankApi = (data) => { 
  return cwslapi({
    url: "/AnimalVoteActivity/getPersonalContributionRank",
    method: "post",
    data,
  });
};


// 获取宠物排行榜
export const getRankListApi = (data) => { 
  return cwslapi({
    url: "/AnimalVoteActivity/getRankList",
    method: "post",
    data,
  });
};


// 宠物投票
export const voteApi = (data) => { 
  return cwslapi({
    url: "/AnimalVoteActivity/vote",
    method: "post",
    data,
  });
};

// 领取每日任务奖励
export const claimDailyTaskRewardApi = (data) => { 
  return cwslapi({
    url: "/AnimalVoteActivity/claimDailyTaskReward",
    method: "post",
    data,
  });
};


// 领取投票额外道具奖励
export const claimUserVoteBonusApi = (data) => { 
  return cwslapi({
    url: "/AnimalVoteActivity/claimUserVoteBonus",
    method: "post",
    data,
  });
};

